import axios from "../axios";

class HomepageService {

    getHomepageData(request, signal) {
        return axios.post("/api/homepage/data", request, { signal }).then(res => res.data);
    }

    getGatewaySummary(request, signal) {
        return axios.post("/api/homepage/gatewaySummary", request, { signal }).then(res => res.data);
    }

    getDocumentAlarm(request, signal) {
        return axios.post("/api/homepage/documentAlarm", request, { signal }).then(res => res.data);
    }

    getDetentionAlert(request, signal) {
        return axios.post("/api/homepage/detentionAlert", request, { signal }).then(res => res.data);
    }

    getDetentionReconciliation(request, signal) {
        return axios.post("/api/homepage/detentionReconciliation", request, { signal }).then(res => res.data);
    }

    getShipmentActivity(request, signal) {
        return axios.post("/api/homepage/shipmentActivity", request, { signal }).then(res => res.data);
    }

    getSupplierScoreboard(request, signal) {
        return axios.post("/api/homepage/supplierScoreboard", request, { signal }).then(res => res.data);
    }

    getOriginSummary(request, signal) {
        return axios.post("/api/homepage/originSummary", request, { signal }).then(res => res.data);
    }
}

export default new HomepageService();